import Vue from 'vue'
import VueRouter from 'vue-router'
import util from '../assets/js/util'
import store from '../store/index'
import dsBridge from '@/api/dsbridge.js'

import error from '../views/error/index'
import main from '@/components/main.vue'

import {
  Toast
} from 'vant'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '/dc-h5s/resumptionWork/',
  routes: [{
      path: '/',
      name: 'main',
      component: () => import('@/components/main.vue'),
      meta: {
        title: '复课攻略'
      }
    }, {
      path: '/student',
      name: 'student',
      component: () => import('@/components/student.vue'),
      meta: {
        title: '复课攻略'
      }
    }, {
      path: '/teacher',
      name: 'teacher',
      component: () => import('@/components/teacher.vue'),
      meta: {
        title: '复课攻略'
      }
    }, {
      path: '/parent',
      name: 'parent',
      component: () => import('@/components/parent.vue'),
      meta: {
        title: '复课攻略'
      }
    },{
      path: '/mainEnd',
      name: 'mainEnd',
      component: () => import('@/components/mainEnd.vue'),
      meta: {
        title: '复课攻略'
      }
    },


  ]
})
router.historyList = [];
router.beforeEach((to, form, next) => {
  // to: Route: 即将要进入的目标 路由对象 ,
  //from: Route: 当前导航正要离开的路由

  try {
    if (to.path) {
      _hmt.push(['_trackPageview', '/dc-mask' + to.fullPath]);
      _hmts.push(['_trackPageview', '/dc-mask' + to.fullPath]);
      _hmtss.push(['_trackPageview', '/dc-mask' + to.fullPath]);
    }
  } catch (e) {
    console.log('埋点调用失败,可能是第一次')
  }
  console.log(util.getUrl(''));
  if (!to.matched.length) { // 是否能找到页面
    next({ // 找不到页面进入应急的404页面
      path: '/',
      replace: true
    })
  } else {
    let option = {};
    option.title = '复课必看|助力“神兽”顺利回笼';
    option.desc = '家长都在转这份复课秘籍';
    if (!util.hasNative() && util.isEquipment().isWeixin) { //不在app里并且在微信里面才去执行
      util.getLoader(to.fullPath, option);
    } else if (util.hasNative()) {
      let urls = util.getUrl('');  //固定分享页为首页
      dsBridge.dsShare({
        link: urls,
        title: option.title,
        summary: option.desc
      });
    }
    util.setTitle(to.meta.title); //设置页面的title

    next();
  }
})

router.afterEach((to, from) => {
  router.historyList.push(to.path);
  window.scrollTo(0, 0);
  // document.getElementById('wrapper') && document.getElementById('wrapper').scrollTo(0, 0);
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js